module.exports = __webpack_public_path__ + "media/images/icon__email@3x-bb97f6497061f3d1e4a42e8cce504491.png";